import { breakpoints, pxToRem, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledSection = styled.div `
  flex-flow: row wrap;
  display: flex;
  gap: ${theme.spacing['3xl']};
  padding: ${theme.spacing.xl} 0;

  ${breakpoints.sm} {
    flex-wrap: nowrap;
  }
`;
export const NoteContainer = styled.div `
  flex: 1 0 ${pxToRem(350)};
  max-width: ${pxToRem(350)};
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing['2xl']};
`;
export const RadioCardContainer = styled.div `
  max-width: calc(100% - ${pxToRem(350)} - ${theme.spacing['3xl']});
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xl};
`;
